import type {ReactElement} from 'react';
import {useAiChat} from '@AiChat/providers/ai-chat.context';
import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {aiChatWindowInspirationsData} from '@AiChat/components/ai-chat-window-inspirations';
import {AiChatSeasonalEmptyState} from '@AiChat/components/ai-chat-seasonal-empty-state/ai-chat-seasonal-empty-state';
import {AiChatSeasonalReturningUserDecorations} from '@AiChat/components/ai-chat-seasonal-returning-user-decorations/ai-chat-seasonal-returning-user-decorations';
import {useAiPromptBox} from '@Components/ai-prompt-box/hooks/useAiPromptBox';
import styles from './ai-chat-empty-state-content.module.scss';

export function AiChatEmptyStateContent(): ReactElement | null {
  const {state} = useAiChat();
  const {isSmall} = useAiChatSize();
  const {actions: promptBoxActions} = useAiPromptBox(state.promptBoxId);

  if (state.currentChatId || state.isPromptBoxOnly || state.isQuickTipsView || state.isAssetsView || state.isMemoryView) {
    return null;
  }

  if (state.isReturningUser) {
    return (
      <div className={styles.returningUserBackgroundClip}>
        <div className={`${styles.returningUserBackground} ${isSmall ? styles.returningUserBackgroundMobile : ''}`} />
        <AiChatSeasonalReturningUserDecorations />
      </div>
    );
  }

  return <AiChatSeasonalEmptyState inspirations={aiChatWindowInspirationsData(promptBoxActions.update)} />;
}
